import { combineReducers } from 'redux'
import {
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_LOADING,
  FORGOT_PASSWORD_SUCCESS,

  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_LOADING,
  RESET_PASSWORD_SUCCESS
} from '../actions/constant'

const forgotPasswordError = (state = false, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_ERROR:
      return action.forgotPasswordError
    default:
      return state
  }
}

const forgotPasswordLoading = (state = false, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_LOADING:
      return action.forgotPasswordLoading
    default:
      return state
  }
}

const forgotPasswordSuccess = (state = false, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_SUCCESS:
      return action.forgotPasswordSuccess
    default:
      return state
  }
}

const resultData = (state = [], action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_SUCCESS:
      return action.resultData
    case FORGOT_PASSWORD_ERROR:
      return action.resultData
    default:
      return state
  }
}

const resetPasswordError = (state = false, action) => {
  switch (action.type) {
    case RESET_PASSWORD_ERROR:
      return action.resetPasswordError
    default:
      return state
  }
}

const resetPasswordLoading = (state = false, action) => {
  switch (action.type) {
    case RESET_PASSWORD_LOADING:
      return action.resetPasswordLoading
    default:
      return state
  }
}

const resetPasswordSuccess = (state = false, action) => {
  switch (action.type) {
    case RESET_PASSWORD_SUCCESS:
      return action.resetPasswordSuccess
    default:
      return state
  }
}

const resultPassword = (state = [], action) => {
  switch (action.type) {
    case RESET_PASSWORD_SUCCESS:
      return action.resultPassword
    case RESET_PASSWORD_ERROR:
      return action.resultPassword
    default:
      return state
  }
}

const forgotPasswordReducer = combineReducers({
  forgotPasswordError,
  forgotPasswordLoading,
  forgotPasswordSuccess,
  resultData,

  resetPasswordError,
  resetPasswordLoading,
  resetPasswordSuccess,
  resultPassword
})

export default forgotPasswordReducer